
export const Fonts = [
    {
        value: 'font-default',
        name: 'BlinkMac (default)',
    },
    {
        value: 'font-NMSFuturaProBook',
        name: 'No Man\'s Sky',
    },
];